import { render, staticRenderFns } from "./WorkspaceTitle.vue?vue&type=template&id=4913b533&scoped=true&"
import script from "./WorkspaceTitle.vue?vue&type=script&lang=js&"
export * from "./WorkspaceTitle.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceTitle.vue?vue&type=style&index=0&id=4913b533&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4913b533",
  null
  
)

export default component.exports